import React from "react";

function HeroWeb3Game() {
  return (
    <div
      className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
      style={{
        backgroundImage: "url(assets/img/bg/launch_your_own_crypto_img.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "80vh",
      }}
    >
      <div className="container mx-auto px-4 pt-[270px] pb-20">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
            Web3 Game Development
          </h2>

          <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
            At Xeer Technology, we specialize in Web3 game development that transforms traditional gaming into a decentralized, transparent, and player-driven experience!


          </p>
        </div>
      </div>
    </div>
  );
}

export default HeroWeb3Game;
